// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"a176fe11","516":"a176fe11","888":"cdb95162"}[chunkId] + ".chunk.css";
};